export function relativeSteering(
  origin: { x: number; y: number },
  anchor: { x: number; y: number },
  point: { x: number; y: number },
  sensitivity: number,
  width: number,
  height: number
) {
  return {
    x: Math.max(0, Math.min(width, anchor.x + (point.x - origin.x) * sensitivity)),
    y: Math.max(0, Math.min(height, anchor.y + (point.y - origin.y) * sensitivity)),
  };
}
